import { useEffect, useRef } from 'react';

import { ONE_QUANTITY } from '@/data/constants/saveForLaterList';
import { useTrackException } from 'presentation/events/hooks/useTrackException';
import { useGetCategories } from 'shared/custom/hooks/Categories';
import { findParentCategories } from 'shared/custom/utils/getCategoryByIdForGA';
import { SendViewItemListEventProps, TrackViewItemListProps } from './types';
import { useTrackViewItemListGA4 } from './useTrackViewItemListGA4';

export const useTrackViewItemList = (params: TrackViewItemListProps) => {
	const trackException = useTrackException();
	const sendGA4Event = useTrackViewItemListGA4();
	const { navigation } = useGetCategories();
	const lastTrackedKeyRef = useRef<string | null>(null);

	useEffect(() => {
		if (!params.products || params.products.length === 0) return;
		if (!navigation || navigation.length === 0) return;
		if (params.pgPromoLoading) return;

		const trackingKey = `${params.products.map((product) => product.id).join(',')}`;
		if (lastTrackedKeyRef.current === trackingKey) return;
		lastTrackedKeyRef.current = trackingKey;

		try {
			const sendEventProps: SendViewItemListEventProps = {
				products: params.products.map((product) => {
					const categories = findParentCategories(navigation, product.parentCatalogGroupID);
					const quantity = ONE_QUANTITY;
					const promoThdCode = params.pgPromoMap?.get(product.id);
					return {
						product: { ...product, promoThdCode },
						categories,
						quantity,
					};
				}),

				listPageName: params.listPageName,
				listId: params.listId,
			};

			sendGA4Event(sendEventProps);
		} catch (e) {
			console.error('Error sending view item list event', e);
			trackException(e);
		}
	}, [
		params?.products,
		params?.listPageName,
		params?.listId,
		params?.pgPromoMap,
		params?.pgPromoLoading,
		sendGA4Event,
		trackException,
		navigation,
	]);
};
